import * as React from "react";
import type { SVGProps } from "react";
const SvgIconShrinkDiagonal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.26 1.07c-.18.04-.11-.03-2.16 2.02l-1.94 1.94V2.01l-.06-.1c-.2-.42-.8-.42-1.02 0l-.05.1v4.56l.04.08c.05.1.18.23.28.28l.08.04h2.24l2.31-.01q.16-.05.28-.18c.25-.27.16-.71-.17-.88l-.1-.05h-1.5l-1.52-.01L12.9 3.9c1.48-1.49 1.94-1.96 1.97-2.01.1-.23.06-.48-.1-.66q-.13-.13-.3-.16c-.11-.02-.12-.02-.22 0M1.99 9.05c-.15.04-.3.19-.36.34-.1.27.02.58.28.71l.1.05h1.51l1.51.01L3.1 12.1c-2.07 2.08-1.98 1.98-2.02 2.18-.02.1 0 .25.05.35.04.08.17.2.25.25.15.07.35.07.52 0 .05-.03.52-.49 2.01-1.97l1.94-1.94v3.02l.06.1q.1.2.3.28c.32.12.67-.07.76-.39.01-.05.02-.61.01-2.3V9.42l-.04-.08c-.05-.1-.18-.23-.28-.28l-.08-.04H4.3c-1.78 0-2.27 0-2.32.02"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconShrinkDiagonal;
